import API from "../../../utils/api";

export const getAutomaticAppsApi = async (filters) => {
  const response = await API.get("settings/automatic-app", { params: filters });
  return { response };
};

export const addAutomaticAppsApi = async (data) => {
  const response = await API.post("settings/automatic-app", data);
  return { response };
};

export const updateAutomaticAppsApi = async (data, id) => {
  const response = await API.put(`settings/automatic-app/${id}`, data);
  return { response };
};

export const deleteAutomaticAppsApi = async (id) => {
  const response = await API.delete(`settings/automatic-app/${id}`);
  return { response };
};
